<script>
    import _ from 'lodash'
    import moment from 'moment'
    import EventBus from '@/components/EventBus'
    import OrgService from '@/request/user/org'
    import OperationService from '@/request/aims/operation'
    export default {
        name: 'AimsArrangeTable',
        props: {
            hid: {
                type: Number,
                default: 0
            },
            height: {
                type: Number,
                default: 650
            },
            currentDate: {
                type: Number,
                default: moment().startOf('day').valueOf()
            }
        },
        data () {
            return {
                tableCellStyle: {
                    padding: 0
                },
                oids: [],
                operations: [],
                operationLoading: false
            }
        },
        computed: {},
        created: function () {
            this.listOids()
            EventBus.$on('websocket-message', this.handleWebsocket)
        },
        mounted: function () {},
        beforeDestroy () {
            EventBus.$off('websocket-message', this.handleWebsocket)
        },
        watch: {
            'hid': function () {
                this.listOids()
            },
            'oids': function () {
                this.listOperation()
            },
            'currentDate': function () {
                this.listOperation()
            }
        },
        methods: {
            listOids () {
                let self = this
                if (!self.hid) {
                    self.oids = []
                    return
                }
                OrgService.listOrgId({
                    pids: self.hid,
                    descendant: 1
                }).then(res => {
                    self.oids = res.result || []
                })
            },
            listOperation () {
                let self = this
                self.operations = []
                if (_.isEmpty(self.oids) || !self.currentDate) {
                    return
                }
                self.operationLoading = true
                let poperation = OperationService.list({
                    start: self.currentDate,
                    end: moment(self.currentDate).endOf('day').valueOf(),
                    orgs: _.join(self.oids),
                    status: '4,5',
                    sort: 'arrangedStartTime,room',
                    order: 'ASC'
                })
                poperation.then(res => {
                    let data = res.result || []
                    if (_.isEmpty(data)) {
                        return
                    }
                    _.remove(data, operation => {
                        if (operation.currentState !== 4 && operation.currentState !== 5) {
                            return true
                        }
                        if (operation.arrangedStartTime < self.currentDate || operation.arrangedStartTime > moment(self.currentDate).endOf('day').valueOf()) {
                            return true
                        }
                        return false
                    })
                    self.operations = _.clone(data)
                    // self.operations = _.sortBy(data, ['arrangedStartTime', 'room'])
                })
                poperation.finally(() => {
                    self.operationLoading = false
                })
            },
            tableTimeFormatter (row, column, cellValue) {
                if (!cellValue) {
                    return ''
                }
                return moment(cellValue).format('HH:mm')
            },
            handleWebsocket (data) {
                if (!data) {
                    return
                }
                if (_.isString(data)) {
                    data = JSON.parse(data)
                }
                if (!data.source || data.source !== 'eber-system-aims') {
                    return
                }
                if (data.topic === 'aims-operation-save') {
                    this.listOperation()
                } else if (data.topic === 'aims-operation-delete') {
                    this.listOperation()
                }
            }
        }
    }
</script>

<template>
    <el-table
            v-loading="operationLoading"
            :data="operations"
            border
            stripe
            size="mini"
            highlight-current-row
            :cell-style="tableCellStyle"
            :header-cell-style="tableCellStyle"
            style="width: 100%">
        <el-table-column prop="arrangedStartTime" label="时间" width="60" :formatter="tableTimeFormatter"></el-table-column>
        <el-table-column prop="historySn" label="病历号" width="70"></el-table-column>
        <el-table-column prop="bedid" label="床号" width="60"></el-table-column>
        <el-table-column prop="patName" label="姓名" width="60"></el-table-column>
        <el-table-column prop="sex" label="性别" width="40">
            <template slot-scope="scope">
                {{ !!scope.row.sex && scope.row.sex % 2 === 0 ? '女' : '男' }}
            </template>
        </el-table-column>
        <el-table-column prop="age" label="年龄" width="40"></el-table-column>
        <el-table-column prop="diagnoseNames" label="诊断+术式">
            <template slot-scope="scope">
                <span>{{scope.row.diagnoseNames}};{{scope.row.operatingNames}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="device" label="设备准备" width="120"></el-table-column>
        <el-table-column prop="specialPrepare" label="器械准备"></el-table-column>
        <el-table-column prop="roomName" label="手术间" width="57" align="center"></el-table-column>
        <el-table-column prop="operatorName" label="主刀" width="60"></el-table-column>
        <el-table-column prop="assistantFirstName" label="一助" width="60"></el-table-column>
        <el-table-column prop="assistantSecondName" label="二助" width="60"></el-table-column>
        <el-table-column prop="washNurseName" label="洗手" width="60">
            <template slot-scope="scope">
                <span>{{scope.row.washNurse || '无'}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="tourNurseName" label="巡回" width="60">
            <template slot-scope="scope">
                <span>{{scope.row.tourNurse || '无'}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="anesthesiaDocName" label="麻醉医生" width="80">
            <template slot-scope="scope">
                <span>{{scope.row.anesthesiaDocName || '未安排'}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="anesthesiaType" label="麻醉方式" width="80">
            <template slot-scope="scope">
                <span>{{scope.row.anesthesiaType || '无'}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注">
            <template slot-scope="scope">
                <span>{{scope.row.remark || '无'}}</span>
            </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="showRecordImages(scope.row)">查看图片</el-button>
          </template>
        </el-table-column> -->
    </el-table>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
